import React, { useEffect, useState } from "react";
import axios from "axios";
import "./PartyAssociates.css"; // Import the CSS file
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../AuthContext";

const salesEmployees = [
  "Aarti",
  "Aarti Sharma",
  "Ajay",
  "Akshay",
  "Akshay Kumar",
  "Anil",
  "Chandni",
  "Dolly",
  "Gobind",
  "Jyoti",
  "Komal",
  "Manpreet",
  "Neetu",
  "Pankaj Bhatt",
  "Pankaj Rawat",
  "Prabhjot",
  "Priya",
  "Rajneesh",
  "Sanju",
  "Sarita",
  "Satyam",
  "Shreya",
  "Suman",
  "Tarun",
  "Tanu",
  "Usha",
  "Yashika",
];

const PartyAssociates = () => {
  const { mobile } = useAuth();
  const [partyAssociates, setPartyAssociates] = useState([]);
  const [filteredAssociates, setFilteredAssociates] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showUnassigned, setShowUnassigned] = useState(false);
  const [employeeName, setEmployeeName] = useState("");

  useEffect(() => {
    fetchPartyAssociates();
  }, []);

  useEffect(() => {
    fetchEmployeeName();
  }, []);

  const fetchEmployeeName = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/employee-name?mobile=${mobile}`
      );
      setEmployeeName(response.data.employee_name); // Assuming the response sends back an object with employee_name
    } catch (error) {
      console.error("Error fetching employee name:", error);
      toast.error("Failed to fetch employee name");
    }
  };

  const fetchPartyAssociates = async (
    search = searchTerm,
    showUnassignedState = showUnassigned
  ) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/party_associates`
      );

      const sortedData = response.data.sort((a, b) =>
        a.party_name.localeCompare(b.party_name)
      );

      setPartyAssociates(sortedData);
      filterAssociates(sortedData, search, showUnassignedState);
    } catch (error) {
      console.error("Error fetching party associates:", error);
      toast.error("Failed to fetch party associates");
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    filterAssociates(partyAssociates, value);
  };

  const handleCheckboxChange = (e) => {
    setShowUnassigned(e.target.checked);
    filterAssociates(partyAssociates, searchTerm, e.target.checked);
  };

  const handleAssociateChange = async (e, associate) => {
    const updatedAssociate = e.target.value;

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/update_associate`,
        {
          partyName: associate.party_name,
          company: associate.company_name,
          newAssociate: updatedAssociate,
        }
      );
      toast.success("Associate updated successfully");
      fetchPartyAssociates(searchTerm, showUnassigned); // Preserve the current search and filter state
    } catch (error) {
      console.error("Error updating associate:", error);
      toast.error("Failed to update associate");
    }
  };

  const filterAssociates = (associates, search, showUnassigned) => {
    const searchLower = search.toLowerCase();
    const filtered = associates.filter((associate) => {
      const matchesSearch =
        associate.party_name.toLowerCase().includes(searchLower) ||
        associate.company_name.toLowerCase().includes(searchLower) ||
        (associate.associate &&
          associate.associate.toLowerCase().includes(searchLower));

      const matchesUnassigned = showUnassigned ? !associate.associate : true;

      return matchesSearch && matchesUnassigned;
    });

    setFilteredAssociates(filtered);
  };

  return (
    <div className="party-associates-container">
      <h1>Party Associates</h1>
      <div className="search-bar-container">
        <input
          type="text"
          placeholder="Search by party name or associate or company..."
          className="search-bar"
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={showUnassigned}
            onChange={handleCheckboxChange}
          />
          Show Unassigned Parties
        </label>
      </div>
      <table className="party-associates-table">
        <thead>
          <tr>
            <th>Party Name</th>
            <th>Company</th>
            <th>Associate</th>
          </tr>
        </thead>
        <tbody>
          {filteredAssociates.map((associate, index) => (
            <tr key={index}>
              <td>{associate.party_name}</td>
              <td>{associate.company_name}</td>
              <td>
                {associate.associate === "" ||
                (associate.associate &&
                  associate.associate
                    .toLowerCase()
                    .includes(employeeName.toLowerCase())) ||
                mobile == "9041677932" ? (
                  <select
                    value={associate.associate || ""}
                    onChange={(e) => handleAssociateChange(e, associate)}
                  >
                    <option value="">Select Associate</option>
                    {salesEmployees.map((employee, i) => (
                      <option key={i} value={employee}>
                        {employee}
                      </option>
                    ))}
                  </select>
                ) : (
                  associate.associate || "N/A"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ToastContainer position="bottom-center" />
    </div>
  );
};

export default PartyAssociates;
